import React, { useEffect, useState } from 'react';
import { FaRunning } from "react-icons/fa";
import { format } from 'date-fns';
import FarmPanel from './Farm';

const Farms = () => {
  const [curNow, setNow] = useState(null);
  const [fresh, setFresh] = useState(null)
  // const [refreshInterval, setRefreshInterval] = useState(5000);
  const [data, setData] = useState(null);
  // auto-refresh
  const refreshHome = () => {
    // update time
    try {
      // setNow(format(new Date().toLocaleString(), 'eee HH:mm:ss'));
    } catch (error) {

    }
  }

  useEffect(() => {
    fetch(`https://ctrl2.cherry2024.com:2096/getservers`)
      .then(response => response.json())
      .then(data => setData(data))
      .catch(error => console.error(error));
    // if (refreshInterval && refreshInterval > 0) {
    //   const interval = setInterval(refreshHome, refreshInterval);
    //   return () => clearInterval(interval);
    // }
  }, [fresh]);

  return (
    <div className="container topLine3">
      <div className="row">
        <div className="col-sm-12">
          {data ?
            <div className="container">
              <div className="row">
                <span className="col-sm-6">
                  <FarmPanel
                    farmServers={data}
                    farmno={1}
                    farmname={"Onsite"}
                  />
                </span>
                <span className="col-sm-6">
                  <FarmPanel
                    farmServers={data}
                    farmno={2}
                    farmname={"Limitless"}
                  />
                </span>
              </div>
              <div className="row">
                <span className="col-sm-6">
                  <FarmPanel
                    farmServers={data}
                    farmno={4}
                    farmname={"Dolphin"}
                  />
                </span>
                <span className="col-sm-6">
                  <FarmPanel
                    farmServers={data}
                    farmno={5}
                    farmname={"Spanish"}
                  />
                </span>
              </div>
              <div className="row">
                <span className="col-sm-12">
                  &nbsp;
                  <div className="padit align-items-center justify-content-center border border-info detailhdr">
                    <FaRunning />=The Bot is running normally. There are no overrides in effect.
                  </div>
                  <div className="padit align-items-center justify-content-center border border-info detailhdr">
                    <span className="up" >on</span>/<span className="down" >off</span>=The Bot is under the control of this panel. This control only lasts for today.
                    Tomorrow, the normal schedule will be applied.
                  </div>
                </span>
              </div>
            </div>
            : <div>'Loading Farms...'</div>}
        </div>
      </div>
    </div>
  )
}

export default Farms;
